import { render, staticRenderFns } from "./EventRemarks.vue?vue&type=template&id=4423e020"
import script from "./EventRemarks.vue?vue&type=script&lang=js"
export * from "./EventRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports